import React from 'react';
import { BrainIcon, ShieldIcon, HeartIcon, CloudRainIcon, BriefcaseIcon, CompassIcon } from 'lucide-react';
export const Issues = () => {
  const issues = [{
    icon: BrainIcon,
    title: 'Тревога и стресс',
    description: 'Навязчивые мысли, напряжение, сложно расслабиться и почувствовать опору'
  }, {
    icon: ShieldIcon,
    title: 'Самооценка и неуверенность',
    description: 'Внутренний критик, ощущение «я недостаточно хорош(а)», стыд, страх совершить ошибку'
  }, {
    icon: HeartIcon,
    title: 'Отношения и близость',
    description: 'Сложности в отношениях с партнёром, родителями, детьми, коллегами, друзьями'
  }, {
    icon: CloudRainIcon,
    title: 'Ничего не радует',
    description: 'Нет сил и интереса к жизни, апатия, всё даётся через усилие, бессмысленность'
  }, {
    icon: BriefcaseIcon,
    title: 'Работа и самореализация',
    description: 'Поиск своего пути, чувство нереализованности, выгорание, потеря мотивации, деньги'
  }, {
    icon: CompassIcon,
    title: 'Жизненные выборы и кризисы',
    description: 'Расставание, переезд, смена профессии, рождение ребёнка, утрата близкого'
  }];
  return <section className="w-full py-10 px-6 md:px-10 bg-white relative overflow-hidden" data-id="element-197">
      <div className="max-w-[1400px] mx-auto" data-id="element-198">
        <div className="text-center mb-12 space-y-3" data-id="element-199">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-200">
            С какими запросами ко мне обращаются
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-201">
          {issues.map((issue, index) => {
          const Icon = issue.icon;
          return <div key={index} className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-all hover:scale-105" data-id="element-202">
                <div className="w-12 h-12 rounded-full bg-[#3d8f5a]/10 flex items-center justify-center mb-4" data-id="element-203">
                  <Icon className="w-6 h-6 text-[#3d8f5a]" data-id="element-204" />
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2" data-id="element-205">
                  {issue.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-206">
                  {issue.description}
                </p>
              </div>;
        })}
        </div>
        <div className="max-w-3xl mx-auto mt-10 text-center" data-id="element-207">
          <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-208">
            Я работаю <span className="font-bold" data-id="element-209">с различными диагнозами</span>
            : тревожно-депрессивным расстройством, паническими атаками, ПТСР,
            пограничным личностным расстройством, РПП, нарциссической травмой и
            др.
          </p>
        </div>
      </div>
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-[#4a9d63] rounded-full opacity-5 blur-3xl pointer-events-none" data-id="element-210"></div>
    </section>;
};